import React from 'react';
import {useState} from 'react';
import {TextField, IconButton, InputAdornment} from '@material-ui/core';
import {Visibility, VisibilityOff} from '@material-ui/icons';

const PasswordInput = ({hidePassword = true, ...props}) => {
  const [showPassword, setShowPassword] = useState(!hidePassword);

  return (
    <TextField
      variant="outlined"
      {...props}
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setShowPassword(!showPassword)}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PasswordInput;



// WEBPACK FOOTER //
// ./src/shared/components/inputs/PasswordInput.tsx